import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="measure-against-toggle"
//
// Shows/hides the Measurement Target number field based on the Measure
// Against select (card #3634, ADR-0126 Amendment 2026-09-19). The number
// field only matters when Measure Against is "Auto" (blank) or
// "A number I set" (task_target) -- for every other source the number is
// ignored, so hiding it avoids implying it still does something.
const VISIBLE_VALUES = ["", "task_target"]

export default class extends Controller {
  static targets = ["select", "targetCountField"]

  connect() {
    this.toggle()
  }

  toggle() {
    if (!this.hasSelectTarget || !this.hasTargetCountFieldTarget) return

    const visible = VISIBLE_VALUES.includes(this.selectTarget.value)
    this.targetCountFieldTarget.classList.toggle("hidden", !visible)
  }
}
